import type { CreateQuestionRequest, UpdateQuestionBody } from '@e-learning/core';
import { createQuestionsApi } from '@e-learning/core';
import { api } from '../../../../api/client';

const questionsApi = createQuestionsApi(api);

/**
 * Hook para gestão do Question Bank no B2B.
 * Usa a API do core com o cliente configurado para B2B.
 */
export function useQuestions() {
  return {
    fetchQuestions: questionsApi.fetchQuestions,
    getQuestion: questionsApi.getQuestion,
    createQuestion: (request: CreateQuestionRequest) =>
      questionsApi.createQuestion(request),
    updateQuestion: (questionId: string, body: UpdateQuestionBody) =>
      questionsApi.updateQuestion(questionId, body),
    deleteQuestion: (questionId: string) =>
      questionsApi.deleteQuestion(questionId),
  };
}
